module.exports = __webpack_public_path__ + "img/04.d49d43cf.png";